export function humanizeString(string: string) {
  return (string[0].toUpperCase() + string.slice(1).toLowerCase()).replace(
    /_/g,
    " ",
  );
}
